import { VOTER_STATES_ERROR_FALLBACK, fetchVoterRegistrationStates, type VoterFetchImpl } from './voterApi';
import { useVoterRequest, type VoterRequestState } from './useVoterRequest';

export type UseVoterRegistrationStatesOptions = {
  fetchImpl?: VoterFetchImpl;
};

export const useVoterRegistrationStates = ({
  fetchImpl,
}: UseVoterRegistrationStatesOptions): VoterRequestState<string[]> =>
  useVoterRequest('registration-states', signal => fetchVoterRegistrationStates({ signal, fetchImpl }), VOTER_STATES_ERROR_FALLBACK, fetchImpl);
